import classNames from "classnames";
import styles from "./AscResourceExploreCard.module.scss";
import AscGenericCard from "../AscCards/AscGenericCard/AscGenericCard";
import AscButton from "../AscButton/AscButton";
import AscLink from "../AscLink/AscLink";

export interface AscResourceExploreCardProps {
  title: string;
  loading?: boolean;
  coverImageUrl: string;
  explorePath: string;
  className?: string;
  skillAmount: number;
  moduleAmount: number;
}

export default function AscResourceExploreCard({
  title,
  loading = false,
  coverImageUrl,
  explorePath,
  skillAmount,
  moduleAmount,
  className,
}: AscResourceExploreCardProps) {
  return (
    <AscGenericCard
      loading={loading}
      title={title}
      className={classNames(styles.ground, className)}
      imageClassName={styles.cardImage}
      coverImageUrl={coverImageUrl}
      bodyClassName={styles.cardBody}
      footer={
        <AscLink
          href={explorePath}
          disabled={!explorePath}
          className={styles.cardBtnLink}
        >
          <AscButton size="medium" fullWidth>
            Explore
          </AscButton>
        </AscLink>
      }
      footerClassName={styles.cardFooter}
    >
      <span className={styles.cardModuleInfo}>
        {skillAmount} Skills | {moduleAmount} Modules
      </span>
    </AscGenericCard>
  );
}
